import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { adminRequest } from '../../utils/adminRequest';

function AdminActivities() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const fetchList = async () => {
    try {
      const res = await adminRequest({ url: '/api/admin/activities', method: 'GET' });
      setList(res.data || []);
    } catch (err) {
      if (err.response?.status === 401) navigate('/admin');
      else alert(err.response?.data?.error || '获取失败');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchList(); }, []);

  const handleDelete = async (id, title) => {
    if (!window.confirm(`确定删除活动「${title}」吗？`)) return;
    try {
      await adminRequest({ url: `/api/admin/activities/${id}`, method: 'DELETE' });
      fetchList();
    } catch (err) {
      alert(err.response?.data?.error || '删除失败');
    }
  };

  const handlePublish = async (id, title) => {
    try {
      await adminRequest({ url: `/api/admin/activities/${id}/publish`, method: 'POST' });
      alert(`活动「${title}」已发布，用户端活动页可见`);
      fetchList();
    } catch (err) {
      alert(err.response?.data?.error || '发布失败');
    }
  };

  const formatPrice = (c) => `¥${(c / 100).toFixed(2)}`;
  const formatDate = (d) => d ? new Date(d).toLocaleString('zh-CN') : '-';

  if (loading) return <div>加载中...</div>;

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <h2>活动列表</h2>
        <Link
          to="/admin/activities/new"
          style={{
            padding: '10px 20px', background: '#6366f1', color: '#fff',
            borderRadius: 8, textDecoration: 'none', fontWeight: 600
          }}
        >
          + 新建活动
        </Link>
      </div>

      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
        gap: 16
      }}>
        {list.map((a) => (
          <div
            key={a.id}
            style={{
              background: '#fff', borderRadius: 12, padding: 20,
              boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
            }}
          >
            <h3 style={{ margin: '0 0 12px', fontSize: 18 }}>{a.title}</h3>
            <p style={{ color: '#666', fontSize: 14, margin: '4px 0' }}>
              📅 {formatDate(a.start_time)}
            </p>
            <p style={{ color: '#666', fontSize: 14, margin: '4px 0' }}>
              📍 {a.location_name}
            </p>
            <p style={{ color: '#888', fontSize: 14, margin: '4px 0' }}>
              状态: {a.status === 'published' ? '已发布' : a.status === 'draft' ? '草稿' : a.status} |
              名额: {a.registered_count}/{a.total_slots || '不限'}
            </p>
            <p style={{ color: '#6366f1', fontSize: 16, margin: '8px 0', fontWeight: 600 }}>
              {formatPrice(a.currentPrice)}
            </p>
            <div style={{ display: 'flex', gap: 8, marginTop: 16, flexWrap: 'wrap' }}>
              {a.status === 'draft' && (
                <button
                  onClick={() => handlePublish(a.id, a.title)}
                  style={{ padding: '8px 14px', background: '#22c55e', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 14 }}
                >
                  发布
                </button>
              )}
              <Link
                to={`/admin/registrations?activityId=${a.id}`}
                style={{ padding: '8px 14px', background: '#e0e7ff', color: '#6366f1', borderRadius: 6, textDecoration: 'none', fontSize: 14 }}
              >
                查看报名
              </Link>
              <Link
                to={`/admin/activities/${a.id}/edit`}
                style={{ padding: '8px 14px', background: '#e0e7ff', color: '#6366f1', borderRadius: 6, textDecoration: 'none', fontSize: 14 }}
              >
                编辑
              </Link>
              <button
                onClick={() => handleDelete(a.id, a.title)}
                style={{ padding: '8px 14px', background: '#fee2e2', color: '#dc2626', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 14 }}
              >
                删除
              </button>
            </div>
          </div>
        ))}
      </div>
      {list.length === 0 && <p style={{ color: '#999', textAlign: 'center', padding: 40 }}>暂无活动</p>}
    </div>
  );
}

export default AdminActivities;
